import { createApp } from 'vue';
import Loading from '@/components/elements/loading-container.vue';
import vClickOutside from 'click-outside-vue3';
import dayjs from 'dayjs';
import { Validate2 } from '@/utils/validate2';
import App from './App.vue';
import router from './router/router';

import store from './store';
import '@/assets/css/modules/bootstrap/bootstrap-grid.scss';
import '@/assets/css/styles.scss';

require('dayjs/locale/ru');

const app = createApp(App);

app.component('AppLoading', Loading);

app.use(store);
app.use(router);
app.use(Validate2);
app.use(vClickOutside);
app.mount('#app');

dayjs.extend(require('dayjs/plugin/relativeTime'));

dayjs.locale('ru');
